"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KtnModelToJSON = exports.KtnModelFromJSONTyped = exports.KtnModelFromJSON = void 0;
function KtnModelFromJSON(json) {
    return KtnModelFromJSONTyped(json, false);
}
exports.KtnModelFromJSON = KtnModelFromJSON;
function KtnModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'staExpirationDate': (new Date(json['staExpirationDate'])),
    };
}
exports.KtnModelFromJSONTyped = KtnModelFromJSONTyped;
function KtnModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'staExpirationDate': (value.staExpirationDate.toISOString().substr(0, 10)),
    };
}
exports.KtnModelToJSON = KtnModelToJSON;
//# sourceMappingURL=KtnModel.js.map